










































































































import { Component, Mixins } from 'vue-property-decorator';
import { Office, MapSettings, OfficeExternalLinkType } from 'client-website-ts-library/types';
import { API } from 'client-website-ts-library/services';
import { AsyncView } from 'client-website-ts-library/plugins';

import Listings from '@/components/Listings.vue';
import TestimonialList from '@/components/Testimonials/TestimonialList.vue';
import Loader from '@/components/UI/Loader.vue';
import Awards from '@/components/Awards.vue';

const Map = () => import('client-website-ts-library/components/Map/Map.vue');

@Component({
  components: {
    Listings,
    TestimonialList,
    Loader,
    Awards,
    Map,
  },
})
export default class CityOffice extends Mixins(AsyncView) {
  private office: Office | null = null;

  private mapSettings: MapSettings | null = null;

  mounted() {
    this.updateOffice('91b553f9-7cbc-4697-bf7d-d70714b674a4');
  }

  getLink(linkType: OfficeExternalLinkType): string {
    return OfficeExternalLinkType[linkType].toString();
  }

  updateOffice(id: string) {
    this.mapSettings = null;

    API.Offices.Get(id).then((office) => {
      this.office = office;

      this.mapSettings = new MapSettings({
        Zoom: 20,
        Interactive: false,
        Padding: 80,
        Markers: [
          {
            Title: `${office.FranchiseName} ${office.OfficeName}`,
            Address: `${office.AddressLine1} ${this.office?.AddressLine2}`,
            Coordinate: office.Coordinate,
          },
        ],
      });
    });
  }
}
